<template>
  <div class="lp-dr-dn" :style="outerStyle">
    <div v-if="vEls" class="outer" @click="vEls=false"></div>
    <div class="sel-el el-item" @click="vEls = true">
      <div :style="divStyles">{{ selectEl.label }}</div>
      <div class="arrow-down"><i class="material-icons">arrow_drop_down</i></div>
    </div>

    <div v-if="vEls" @click="vEls=false" class="els">
      <div v-for="(el,idx) in els" @key="idx" @click="clickEl(el)" class="el-item item">
        <div :style="divStyles">{{ el.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LpDropdown',
    props: {
      outerStyle: {
        type: Object,
        default: () => {
          return {
            border: '1px solid #ddd',
            borderRadius: '4px'
          }
        }
      },
      styles: {
        type: Object,
        default: () => {
          return {
            width: '100%',
            fontSize: '13px',
            textAlign: 'left'
          }
        }
      },
      ele: {
        required: false
      },
      options: {
        type: Array,
        required: true
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    watch: {
      options() {
        this.init();
      }
    },
    created() {
      this.init();
    },
    data() {
      return {
        divStyles: '',
        selectEl: {label: '', value: ''},
        vEls: false,
        els: [

        ]
      }
    },
    methods: {
      init() {
        this.els = this.options;
        if(this.ele === '' || this.ele === undefined || this.ele === null) {
          if(this.placeholder === '') {
            this.selectEl = this.els[0];
          } else {
            this.selectEl.label = this.placeholder;
          }
        }
        else {
          this.selectEl = find(this.els, 'value', this.ele);
        }

        if(this.styles !== undefined)
          this.divStyles = this.styles;
      },
      clickEl(el) {
        this.selectEl = el;
        this.$emit('update:ele', el.value);
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  .lp-dr-dn
    position relative

  .sel-el
    padding 8px
    cursor pointer


  .els
    position absolute
    min-width 56px
    width 100%
    background white
    box-shadow 0px 4px 4px 1px rgba(0,0,0,0.13)
    left 0
    z-index 1

  .el-item
    width 100%
    padding 8px
    display table


  .item:hover
    background-color #eee
    cursor pointer

  .el-item div
    display table-cell
    vertical-align middle


  .arrow-down
    color #787878
    width 20px

  .outer
    position fixed
    top 0
    left 0
    right 0
    bottom 0

</style>
